import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { MembershipStatus } from '@fitscovery/membership/data-access';
import { MembershipButtonService } from './membership-button.service';

@Component({
  selector: 'fitscovery-membership-button',
  templateUrl: './membership-button.component.html',
  styleUrls: ['./membership-button.component.scss']
})
export class MembershipButtonComponent implements OnInit {

  buttonStatus: MembershipStatus;

  constructor(
    private service: MembershipButtonService
  ) { }

  ngOnInit(): void {
    this.setButtonTextByMembershipStatus();
  }

  setButtonTextByMembershipStatus() {
    this.service.userAndMembership$.pipe(
      take(5)
    ).subscribe((data) => {

      if (!data.isAuthenticated) {
        this.buttonStatus = -3;
      } else if (data.isAuthenticated && data.hasActiveMembership && !data.hasActiveFreeMembership && !data.hasUpgradeFreeMembership) {
        this.buttonStatus = MembershipStatus.Active;
      } else if (data.isAuthenticated && data.hasPendingMembership) {
        this.buttonStatus = MembershipStatus.Pending;
      } else if (data.isAuthenticated && data.hasActiveFreeMembership) {
        this.buttonStatus = -1;
      } else if (data.isAuthenticated && data.hasUpgradeFreeMembership) {
        this.buttonStatus = -2;
      } else {
        this.buttonStatus = -3;
      }
    });
  }

}
